<div
  class="login-register" ngClass.lt-md="align-items-sm login-register"
  style="background-image: url(assets/images/background/download.jpg)">
  <div class="singup-details">
    <mat-card>
      <mat-card-content>
        <h4 class="text-center">Sign-Up</h4>
        <p class="font-14 text-center">You've successfully authenticated. We just need a few more details.</p>
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
          <div fxLayout="row wrap">
            <div fxLayout="row wrap" fxFlexAlign="start" fxFlex="100">
              <div fxFlex.gt-sm="50" fxFlex="100" ngClass.gt-sm="p-r-5">
                <mat-form-field>
                  <input matInput placeholder="First Name" type="text" [formControl]="controls.firstName" />
                  <mat-error *ngIf=" displayRequiredValidationMessage('firstName')"> You must include your first name. </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex.gt-sm="50" fxFlex="100" ngClass.gt-sm="p-l-5" fxFlexAlign="center">
                <mat-form-field>
                  <input matInput placeholder="Last Name" type="text" [formControl]="controls.lastName" />
                  <mat-error *ngIf=" displayRequiredValidationMessage('lastName')"> You must include your last name. </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="100">
                <mat-form-field>
                  <input matInput placeholder="Mobile" type="text" [formControl]="controls.mobile" />
                  <mat-error *ngIf=" displayRequiredValidationMessage('mobile')"> You must include your mobile phone number. </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="100">
                <mat-form-field>
                  <mat-select placeholder="Your Position" [formControl]="controls.yourPosition">
                    <mat-option *ngFor="let position of allPositions" [value]="position">{{ position }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="displayRequiredValidationMessage('yourPosition')">You must include your position in the company. </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="100" *ngIf="!showCompanyList">
                <mat-form-field>
                  <input matInput placeholder="Company Name" type="text" [formControl]="controls.companyName" />
                  <mat-error *ngIf="displayRequiredValidationMessage('companyName')">You must include your company's name.</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="100" *ngIf="!showCompanyList">
                <mat-form-field>
                  <input matInput placeholder="Company Website" type="text" [formControl]="controls.website" />
                </mat-form-field>
              </div>


              <div fxFlex="100" *ngIf="!showCompanyList">
                <mat-form-field>
                  <mat-select placeholder="Company Type" [formControl]="controls.companyType">
                    <mat-option *ngFor="let type of companyTypes" [value]="type">{{ type }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="displayRequiredValidationMessage('type')">You must specify the type of company you are signing up. </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="100" *ngIf="showCompanyList">
                <mat-form-field>
                  <mat-select placeholder="Your Company" [formControl]="controls.companies">
                    <mat-option *ngFor="let company of companies" [value]="company?.id">{{ company?.name ?? "" }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout="row wrap" fxFlexAlign="start" fxFlex="100" [fxHide]="showCompanyList">
                <div fxFlex="100">
                  <address-auto-complete
                    id="postal-address"
                    tagId="postal-address"
                    placeholder="Postal Address"
                    (setAddress)="getPostalAddress($event)"
                    addressType={{addressType}}>
                  </address-auto-complete>
                </div>
              </div>

              <input [formControl]="controls.postalAddress" style="display: none;"/>
              <mat-error *ngIf="displayRequiredValidationMessage('postalAddress')">You must include a postal address.</mat-error>

              <div fxLayout="row wrap" fxFlexAlign="start" fxFlex="100" [fxHide]="showCompanyList || controls.sameAsPostal.value">
                <div fxFlex="100">
                  <address-auto-complete
                    id="street-address"
                    tagId="street-address"
                    placeholder="Street Address"
                    (setAddress)="getStreetAddress($event)"
                    addressType={{addressType}}>
                  </address-auto-complete>
                </div>
              </div>

              <div fxLayout="row wrap" fxFlexAlign="start" fxFlex="100" *ngIf="!showCompanyList">
                <div fxFlex="100">
                  <mat-checkbox color="primary" [formControl]="controls.sameAsPostal">Use postal address for street address</mat-checkbox>
                </div>
              </div>

              <div fxFlex="100" *ngIf="isCompanyListPopulated">
                <a class="font-75" (click)="companyListAnchorClick()">{{companyListMessage}}</a>
              </div>

            </div>
            <div fxLayout="row wrap" fxFlexAlign="start" fxFlex="100" fxFlex.gt-sm="50" ngClass.gt-sm="p-l-20">
            </div>
          </div>

          <button mat-raised-button color="primary" class="btn-block btn-lg m-t-20 m-b-20" type="submit" [disabled]="!formGroup.valid">
            Submit
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
